const sizeViewboxes = {
    '16px': '0 0 16 16',
    '24px': '0 0 24 24',
    '32px': '0 0 32 32',
};
export { sizeViewboxes };
//# sourceMappingURL=constants.js.map